var _style, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssociat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-good-doggy",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnssvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-good-doggy:not(.animated) .animable {opacity: 0;}svg#freepik_stories-good-doggy.animated #freepik--Floor--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn,1.5s Infinite  linear wind;animation-delay: 0s,1s;}svg#freepik_stories-good-doggy.animated #freepik--Plants--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-good-doggy.animated #freepik--Clouds--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown,1.5s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-good-doggy.animated #freepik--Character--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-good-doggy.animated #freepik--Doggy--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}            @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes wind {                0% {                    transform: rotate( 0deg );                }                25% {                    transform: rotate( 1deg );                }                75% {                    transform: rotate( -1deg );                }            }                    @keyframes zoomOut {                0% {                    opacity: 0;                    transform: scale(1.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }                    @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2",
    className: "animable",
    style: {
      transformOrigin: "259.86px 357.78px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--floor--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.86,
    cy: 357.78,
    rx: 217.44,
    ry: 114.72,
    style: {
      fill: "rgb(235, 235, 235)",
      opacity: 0.7,
      transformOrigin: "259.86px 357.78px"
    },
    className: "animable",
    id: "elficjokxzbb6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2",
    className: "animable",
    style: {
      transformOrigin: "251.65px 343.49px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 161.46,
    cy: 371.83,
    rx: 64.16,
    ry: 37.04,
    style: {
      opacity: 0.07,
      transformOrigin: "161.46px 371.83px"
    },
    className: "animable",
    id: "elgdzq3yc9vu"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 314.94,
    cy: 330.68,
    rx: 91.06,
    ry: 52.57,
    style: {
      opacity: 0.07,
      transformOrigin: "314.94px 330.68px"
    },
    className: "animable",
    id: "eldl22rjkixc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2",
    className: "animable",
    style: {
      transformOrigin: "261.5px 276.365px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-2",
    className: "animable",
    style: {
      transformOrigin: "440.723px 282.486px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.09,312.81l-7.69-4.39s-3.69-20.31-.93-37.78c3.88-24.55,20.59-33,26.67-30.58s7.49,9.72-3.47,23.9C435.2,272.33,426.88,290,427.09,312.81Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "433.632px 276.236px"
    },
    id: "elaj275w7h0v4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elk3u2uahggz8"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "433.632px 276.236px"
    },
    className: "animable",
    id: "el8kmqd81kw8h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.09,312.81l-7.69-4.39s-3.69-20.31-.93-37.78c3.88-24.55,20.59-33,26.67-30.58s7.49,9.72-3.47,23.9C435.2,272.33,426.88,290,427.09,312.81Z",
    id: "el2s6mlzaq4gr",
    className: "animable",
    style: {
      transformOrigin: "433.632px 276.236px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M424.3,303.06h.08a.54.54,0,0,0,.46-.62c-3.17-23,6.07-48.17,16.46-58.32a.56.56,0,0,0,0-.78.55.55,0,0,0-.78,0c-10.57,10.33-20,35.92-16.77,59.25A.55.55,0,0,0,424.3,303.06Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "432.282px 273.119px"
    },
    id: "el2qlrfznih55",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.41,325.13c1.22.7,3.72-.83,4.68-1.47a11.57,11.57,0,0,0,3.85-4.42,10.89,10.89,0,0,0,1-6.53,26,26,0,0,0-.83-3.46c-.32-1.13-.64-2.25-1-3.37a8.62,8.62,0,0,1-.49-3.4c.3-2.3,2.34-3.91,4.2-5.3,2.05-1.54,4.19-3.57,4.18-6.35a9.78,9.78,0,0,0-2.44-5.8c-1.33-1.68-2.9-3.16-4.1-4.93a6.84,6.84,0,0,1-1.39-4.31,7.07,7.07,0,0,1,.93-2.69,38.82,38.82,0,0,0,2.95-5.4c.68-1.94.58-4.35-.93-5.74a6.36,6.36,0,0,0-4.77-1.19,11,11,0,0,0-4.44,1.57c-4.4,2.44-6.91,7.66-11.58,9.54a49.16,49.16,0,0,1-5.66,1.38c-1.87.5-3.79,1.46-4.66,3.19-1.71,3.43,1.47,7.65.26,11.28-1.06,3.22-4.19,4.45-5.94,7.35a6.8,6.8,0,0,0-.82,4.21,20.15,20.15,0,0,0,1.77,7.11,50.11,50.11,0,0,0,3.91,6.41C427.16,312.89,448.23,325,448.41,325.13Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "442.677px 293.003px"
    },
    id: "elo2c530lwwq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.93,318.48h0a.54.54,0,0,0,.53-.57c-.9-21.75,9.35-45.77,16.8-52.75a.55.55,0,0,0,0-.77.54.54,0,0,0-.78,0c-7.6,7.12-18.06,31.54-17.14,53.6A.54.54,0,0,0,435.93,318.48Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "444.35px 291.353px"
    },
    id: "ell9gwy24zhc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.19,292.78l.17,0a73.58,73.58,0,0,1,15.78-2.55.55.55,0,0,0,.53-.57.52.52,0,0,0-.57-.52A74.72,74.72,0,0,0,439,291.71a.55.55,0,0,0,.16,1.07Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "447.149px 290.959px"
    },
    id: "elyptd8zpce7k",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-2",
    className: "animable",
    style: {
      transformOrigin: "83.8177px 273.082px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.36,305.42l8.19-4.68s3.93-21.67,1-40.29c-4.14-26.17-22-35.2-28.44-32.6s-8,10.36,3.7,25.48C89.71,262.26,98.58,281.12,98.36,305.42Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "91.3845px 266.421px"
    },
    id: "elvedu2amrl2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnurfdk3yjxr"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "91.3845px 266.421px"
    },
    className: "animable",
    id: "el4sb3ytf23xl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.36,305.42l8.19-4.68s3.93-21.67,1-40.29c-4.14-26.17-22-35.2-28.44-32.6s-8,10.36,3.7,25.48C89.71,262.26,98.58,281.12,98.36,305.42Z",
    id: "elnksdv0r8ce",
    className: "animable",
    style: {
      transformOrigin: "91.3845px 266.421px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M101.33,295h-.08a.59.59,0,0,1-.5-.66c3.39-24.51-6.47-51.36-17.54-62.19a.58.58,0,0,1,.81-.83c11.28,11,21.32,38.31,17.89,63.18A.58.58,0,0,1,101.33,295Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "92.8183px 263.082px"
    },
    id: "eltl57q36u8sc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.62,318.55c-1.29.75-4-.88-5-1.56a12.4,12.4,0,0,1-4.11-4.72,11.52,11.52,0,0,1-1-7,26.52,26.52,0,0,1,.88-3.7c.34-1.19.68-2.39,1-3.59a9,9,0,0,0,.52-3.62c-.31-2.45-2.49-4.17-4.47-5.66C61.27,287.1,59,284.94,59,282a10.43,10.43,0,0,1,2.6-6.19C63,274,64.69,272.42,66,270.53a7.24,7.24,0,0,0,1.49-4.59,7.46,7.46,0,0,0-1-2.87c-1-1.92-2.42-3.69-3.14-5.75s-.62-4.64,1-6.12c1.32-1.22,3.29-1.39,5.08-1.27a11.63,11.63,0,0,1,4.73,1.67c4.69,2.61,7.37,8.16,12.35,10.17a47.34,47.34,0,0,0,6,1.47c2,.53,4,1.56,5,3.41,1.83,3.65-1.56,8.15-.28,12,1.14,3.43,4.47,4.75,6.34,7.84a7.33,7.33,0,0,1,.88,4.49,21.65,21.65,0,0,1-1.9,7.58,53.43,53.43,0,0,1-4.16,6.84C98.28,305.5,75.82,318.44,75.62,318.55Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "81.7531px 284.32px"
    },
    id: "eldfh657zwy7f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.93,311.47h0a.6.6,0,0,1-.57-.61c1-23.2-10-48.81-17.91-56.25a.59.59,0,0,1,0-.83.6.6,0,0,1,.83,0c8.1,7.59,19.26,33.63,18.28,57.16A.58.58,0,0,1,88.93,311.47Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "79.9499px 282.543px"
    },
    id: "elxdrgixvpuhk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.45,284.06a.47.47,0,0,1-.17,0,78.48,78.48,0,0,0-16.84-2.71.59.59,0,0,1-.56-.61.57.57,0,0,1,.61-.56,79.65,79.65,0,0,1,17.13,2.77.58.58,0,0,1-.17,1.14Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "76.965px 282.135px"
    },
    id: "elwnijydxa40i",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-2",
    className: "animable",
    style: {
      transformOrigin: "135.61px 79.807px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clouds--inject-2",
    className: "animable",
    style: {
      transformOrigin: "135.61px 79.807px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.4,60.28,122,65.71a13.86,13.86,0,0,0,.08-1.43V61.13c0-5.6-3.4-8.17-7.6-5.75A14,14,0,0,0,109.94,60c-.69-7.1-5.47-10.15-11.28-6.8C92.38,56.84,87.29,66.57,87.29,75v4.7a14.62,14.62,0,0,0,1,5.54L80.44,89.7c-2.33,1.34-4.22,5-4.22,8.06s1.89,4.53,4.22,3.18l51-29.42c2.32-1.34,4.21-5,4.21-8S133.72,58.93,131.4,60.28Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "105.935px 76.6412px"
    },
    id: "ele4gp414ct5b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.82,76.7l-7.1,4.1a9.77,9.77,0,0,0,.06-1.08V77.35c0-4.23-2.57-6.17-5.74-4.34a10.58,10.58,0,0,0-3.42,3.49c-.52-5.36-4.13-7.66-8.51-5.13-4.74,2.74-8.58,10.08-8.58,16.4v3.55a11.18,11.18,0,0,0,.72,4.18l-5.89,3.41a7.59,7.59,0,0,0-3.18,6.08c0,2.34,1.42,3.42,3.18,2.4l38.46-22.2A7.61,7.61,0,0,0,195,79.11C195,76.77,193.58,75.69,191.82,76.7Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "172.59px 89.0582px"
    },
    id: "el6y4ajyadfkl",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2",
    className: "animable",
    style: {
      transformOrigin: "295.952px 220.767px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-2",
    className: "animable",
    style: {
      transformOrigin: "295.952px 220.767px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.85,339.1c2.87,1.53,9,1.11,13.93-2.16s6.13-10.63,4.34-16c-2.18-6.5-6-9.68-7.43-13.57s-1.36-9.59-3.18-13a10.4,10.4,0,0,0-7-5.1,6.26,6.26,0,0,0-5.38,1.27l-1.44,1.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "383.297px 314.532px"
    },
    id: "elmu43aszr6z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.28,319l5.56,7.36s-1.32,9.22.49,11.35c2.67,3.15,6.58,3.22,12.73.32,7-3.31,7.8-10.22,6.68-15.34-1.58-7.29-9.21-11.85-9.46-19.05s-4.93-16.43-13.82-11.2c-6.31,3.58-11.76,10.1-11.76,10.1Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "375.428px 315.523px"
    },
    id: "elan3h5hh2h0s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.84,326.31a18.64,18.64,0,0,1,8.32-3.17,1.37,1.37,0,0,0,1.18-2l0,0a1.35,1.35,0,0,0-1.31-.75c-2,.13-6.87.78-9.7,3.89C370.73,326.18,372.84,326.31,372.84,326.31Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "376.858px 323.348px"
    },
    id: "eljlm0otskld",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.45,321.82a18.57,18.57,0,0,1,8.14-3.59,1.37,1.37,0,0,0,1.07-2v0a1.37,1.37,0,0,0-1.35-.69c-2,.24-6.82,1.14-9.48,4.39C367.33,321.8,369.45,321.82,369.45,321.82Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "373.286px 318.676px"
    },
    id: "elx09qrfpgay",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elkrumjl0wdsl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.84,326.31a18.64,18.64,0,0,1,8.32-3.17,1.37,1.37,0,0,0,1.18-2l0,0a1.35,1.35,0,0,0-1.31-.75c-2,.13-6.87.78-9.7,3.89C370.73,326.18,372.84,326.31,372.84,326.31Z",
    style: {
      opacity: 0.3,
      transformOrigin: "376.858px 323.348px"
    },
    className: "animable",
    id: "elv93zygsgdr"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elrif4gyfnyea"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.45,321.82a18.57,18.57,0,0,1,8.14-3.59,1.37,1.37,0,0,0,1.07-2v0a1.37,1.37,0,0,0-1.35-.69c-2,.24-6.82,1.14-9.48,4.39C367.33,321.8,369.45,321.82,369.45,321.82Z",
    style: {
      opacity: 0.3,
      transformOrigin: "373.286px 318.676px"
    },
    className: "animable",
    id: "elg43ogofrp0p"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M287.65,336l-16.54-6.56c.27-4.26-2.65-11.39-5.51-18.44l19.51-6.28,5,18.79Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "277.855px 320.36px"
    },
    id: "el3xahseq0cll",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.44,350.53a5.6,5.6,0,0,0,.23,4.06c.57,1.19,6.77,4.68,15.13,4.12a34.79,34.79,0,0,0,17.3-6c3.19-2.11,6.51-2.5,10.65-2.74s9.58-2.3,10.49-4.24-.14-5.27-.14-5.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "267.388px 349.615px"
    },
    id: "el6463f1dscqc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.2,324.43l-.67-.14a2.73,2.73,0,0,0-1.1-.06,2.14,2.14,0,0,0-1,.7,21.18,21.18,0,0,0-2.14,3.35c-1.75,2.86-5.43,5.23-9.45,7.39-2.73,1.47-5.41,2.61-8.23,3.88s-6.7,2.08-9,3.6c-3.28,2.21-3.71,7.77,0,10,3.23,1.89,11.72,3.94,20.62,1.42,4.85-1.37,10.23-6.55,16.6-7.05,4-.32,11.7-1.46,14.3-4.53,1-1.36-.32-5.68-1.38-9.42-1.15-4.07-1.57-11.25-2.92-10.89,0,0,.36,1-.16,1.56s-2.39,1.63-2.93,2.1a10.58,10.58,0,0,0-2.24,3.22,2.4,2.4,0,0,1-1.15,1.24c-.68.26-1.19-.17-1.79-.44a3.49,3.49,0,0,0-2.42-.18,15.18,15.18,0,0,1,.43-2.39,1.45,1.45,0,0,0,.06-.77,1.27,1.27,0,0,0-.52-.58A13.07,13.07,0,0,0,274.2,324.43Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "267.236px 339.204px"
    },
    id: "eleulrbdk1los",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.59,333.47a3.76,3.76,0,0,1,3-2c1.84-.34,5.09,1,7.12,2.68a1.52,1.52,0,0,1-.22,2.5h0a1.55,1.55,0,0,1-1.73-.19A11.54,11.54,0,0,0,263.59,333.47Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "268.928px 334.123px"
    },
    id: "el6o95o789u9r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.88,336.67a4.34,4.34,0,0,1,3.54-1.83s4.81.14,7.79,2.92a1.47,1.47,0,0,1-.2,2.41h0a1.44,1.44,0,0,1-1.66-.19A11.57,11.57,0,0,0,257.88,336.67Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "263.813px 337.595px"
    },
    id: "eldste8miva3n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.58,339.55a4.85,4.85,0,0,1,3.68-1.65,12.94,12.94,0,0,1,7.45,2.94,1.48,1.48,0,0,1-.2,2.42h0a1.45,1.45,0,0,1-1.66-.2A11.07,11.07,0,0,0,251.58,339.55Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "257.413px 340.667px"
    },
    id: "el8nldjxjngkd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elesmjeaxlqgo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.59,333.47a3.76,3.76,0,0,1,3-2c1.84-.34,5.09,1,7.12,2.68a1.52,1.52,0,0,1-.22,2.5h0a1.55,1.55,0,0,1-1.73-.19A11.54,11.54,0,0,0,263.59,333.47Z",
    style: {
      opacity: 0.3,
      transformOrigin: "268.928px 334.123px"
    },
    className: "animable",
    id: "ell0wl18jher"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el2ufmzc8qvhd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.88,336.67a4.34,4.34,0,0,1,3.54-1.83s4.81.14,7.79,2.92a1.47,1.47,0,0,1-.2,2.41h0a1.44,1.44,0,0,1-1.66-.19A11.57,11.57,0,0,0,257.88,336.67Z",
    style: {
      opacity: 0.3,
      transformOrigin: "263.813px 337.595px"
    },
    className: "animable",
    id: "el9scqrtkwh9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elfpdkfwucqg9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.58,339.55a4.85,4.85,0,0,1,3.68-1.65,12.94,12.94,0,0,1,7.45,2.94,1.48,1.48,0,0,1-.2,2.42h0a1.45,1.45,0,0,1-1.66-.2A11.07,11.07,0,0,0,251.58,339.55Z",
    style: {
      opacity: 0.3,
      transformOrigin: "257.413px 340.667px"
    },
    className: "animable",
    id: "elfl3yc7n8laj"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M357.7,246.59c1.62,6.74,2.64,20-.17,30.18s-12.21,27.1-12.21,27.1l18.51-8.39s4.35-.17,8.33,6,0,15.35,0,15.35-22.58,17.73-40,28.23c-17.25,10.38-26.3,11.28-37.57,6.09-6.47-3-6.88-14-3.56-25.52s16.17-48,16.17-48l-29.46,2.18,11.14,33.61s-5.36,9.77-21.12,6.44c0,0-25.37-41.75-28.65-53.06s-1.28-20.19,11-22.94c12.66-2.84,43-5.42,43-5.42Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "305.817px 296.341px"
    },
    id: "ell386rqor0u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmj4qboir74h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.7,246.59c1.62,6.74,2.64,20-.17,30.18s-12.21,27.1-12.21,27.1l18.51-8.39s4.35-.17,8.33,6,0,15.35,0,15.35-22.58,17.73-40,28.23c-17.25,10.38-26.3,11.28-37.57,6.09-6.47-3-6.88-14-3.56-25.52s16.17-48,16.17-48l-29.46,2.18,11.14,33.61s-5.36,9.77-21.12,6.44c0,0-25.37-41.75-28.65-53.06s-1.28-20.19,11-22.94c12.66-2.84,43-5.42,43-5.42Z",
    style: {
      opacity: 0.5,
      transformOrigin: "305.817px 296.341px"
    },
    className: "animable",
    id: "elsz64erweik"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elvlnib17me9p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.22,277.62l2.46-4.6s-8.23-7.23-11.08-15.11c0,0,1.19,9.91,5.54,16l-14.79,4.78Z",
    style: {
      opacity: 0.15,
      transformOrigin: "299.515px 268.3px"
    },
    className: "animable",
    id: "elhteq50wxujo"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ellarmrvy0hf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.24,318.16c7.91-10.14,24.81-20.18,24.87-20.22-3.3-2.8-5.28-2.46-5.28-2.46l-18.51,8.39s-11.2,24.22-20.31,27.91A43.16,43.16,0,0,0,344.24,318.16Z",
    style: {
      opacity: 0.15,
      transformOrigin: "347.06px 313.624px"
    },
    className: "animable",
    id: "elid0cnm3thuf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el0c5t9o8h5sza"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.76,279.8c0-2.12-4.36-11.12-12.16-14.3a22.7,22.7,0,0,1,15.88,14Z",
    style: {
      opacity: 0.15,
      transformOrigin: "273.54px 272.65px"
    },
    className: "animable",
    id: "elq90om6li12"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M292.39,152.66c-4.95-.45-12,7.44-16,19.93s-23.45,53.58-23.45,53.58L196,225.23l9.11,16.18s43.4,3.53,50.12,4c9.37.65,11.55-1,15.39-6.74s18.17-30.89,18.17-30.89Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "244.195px 199.092px"
    },
    id: "elm5pm1l6x2g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.28,151.59A16.78,16.78,0,0,0,285,155.33c-4.32,3.53-7.81,9.3-12.07,19.68-3.38,8.22-16.35,39.89-16.35,39.89A32,32,0,0,0,280,226.39l22.71-44.54Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "279.645px 188.983px"
    },
    id: "el2gcrgmbj0ed",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.7,174.88c5.46,20.53,12.53,74.68,12.53,74.68-8.94,10.39-50.19,9.92-67.06-11.13-2-16.65-6.55-29.88-10.2-59.67-1.61-13.13,1.55-22.27,13.88-27.22l22.91.05,15,.27C340.94,156.25,343.64,167.14,345.7,174.88Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "319.406px 203.867px"
    },
    id: "elo4hlq4ngwqd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.44,254.41c16.4,3.71,33.42,1.39,38.79-4.85,0,0-7.07-54.15-12.53-74.68a97.79,97.79,0,0,0-3.18-10.39l-14.7,2.58c-.24,5.83,6.61,27.21,11.48,39,4.21,10.23,7.16,21.35,6.35,28.6S338.81,256,319.44,254.41Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "338.835px 210.339px"
    },
    id: "eld12rucrc91p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.27,104.39a19.68,19.68,0,1,1-21.2-18A19.68,19.68,0,0,1,308.27,104.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "288.656px 106.006px"
    },
    id: "elmyxa069c81",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.69,117.19s-2,15.2-3.05,17.76a6.8,6.8,0,0,1-3.66,3.46l-.62-10.52Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "320.025px 127.8px"
    },
    id: "el7frdjv1zmz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,96.11a7.39,7.39,0,0,1,6.27,1.66c2.83,2.46,2,11-.56,19.42l-5.93,1.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "321.912px 107.165px"
    },
    id: "el8bo6z26xhmd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,118.51c1.26.62,2.79-1.82,4.14-3.49s6-4.18,8.85.71-1.17,12.2-4.88,13.7c-6.39,2.58-7.71-1.54-7.71-1.54l1.4,23.7c-5.15,6.77-25.47,13.29-21.39,1.09l-.57-7.2a76,76,0,0,1-8.8,1.16c-3.35.07-7.17-2.11-9.71-9.4-3.16-9.12-3.93-21-3-33,1.21-16.34,20.59-18.32,32.52-12.09S316,118.51,316,118.51Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "301.958px 124.201px"
    },
    id: "el5fn97oxqorn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.12,120.53c.53-.3,2.6-4,4-5.51C322,113,318,96.11,318,96.11s1.65-4.4-2.69-8.47a17.23,17.23,0,0,0-16.69-4.23c-5.85,1.54-11.82,3.41-17.89,2.28-3-.55-6-1.42-9-1.56a1.37,1.37,0,0,0-1,.23,1.33,1.33,0,0,0-.28,1.1,9.26,9.26,0,0,0,2.17,5.37l-3.79-.8a.73.73,0,0,0-1.06.82,8.93,8.93,0,0,0,3.17,7.05c4.27,3.56,8.75,4.5,14.26,4.54a66.32,66.32,0,0,0,21.38-3c2.2-.48,2.85,1.64,4.53,7.44C312.51,112,311.53,123.19,316.12,120.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "294.185px 101.848px"
    },
    id: "el3r45i9rpyr3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.07,97.44,325,93a4,4,0,0,0-5.64-1.38A4.35,4.35,0,0,0,318.07,97.44Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "321.229px 94.2114px"
    },
    id: "elbw9iorkrfjd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.8,145.48s10.6-3,14.2-5.34a12.42,12.42,0,0,0,4.79-5.57,16.91,16.91,0,0,1-2.46,6.31c-2.48,3.74-16.29,7.46-16.29,7.46Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "305.295px 141.455px"
    },
    id: "el6g4a685e7za",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.89,117.56a2.16,2.16,0,1,0,2-2.42A2.2,2.2,0,0,0,294.89,117.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "297.036px 117.295px"
    },
    id: "el24dnc60w3uhi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.45,109.46l4.82,2.17A2.78,2.78,0,0,0,299.9,108,2.59,2.59,0,0,0,296.45,109.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "298.976px 109.709px"
    },
    id: "eliy0wv45qz7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.85,132.4l-4.78,2.24a2.6,2.6,0,0,0,3.48,1.37A2.78,2.78,0,0,0,296.85,132.4Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "294.579px 134.322px"
    },
    id: "el60tnv5nhpap",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.9,113.38l4.46-2.92a2.56,2.56,0,0,0-3.61-.85A2.8,2.8,0,0,0,274.9,113.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "276.931px 111.286px"
    },
    id: "elpburwilrhgk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.21,118.75a2.16,2.16,0,1,0,2-2.42A2.19,2.19,0,0,0,277.21,118.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "279.355px 118.485px"
    },
    id: "el511ks8sxund",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.76 115.58 290.99 128.53 283.04 128.31 288.76 115.58",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "287.015px 122.055px"
    },
    id: "elwmzotg7zf6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,220.74c1.07-4.2-5.73-19.19-14-35.19-14.44-27.78-20.73-33.33-32.86-32.55l3.78,31.74,22.12,36c-.57,3-5.78,20.53-11,30.4a8.1,8.1,0,0,1-4.36,3.74c-5,1.85-7.35,4.31-11.39,7.1-3.16,2.19-5.52,2.41-5.35,3.34.21,1.21,1.69,3.39,5.08,3.08a31.18,31.18,0,0,0,7-2.1,43.19,43.19,0,0,1-8.67,9.34c-7.75,6.3-11.79,11.26.67,14,7.8,1.69,17.95-3,27.41-19.06,2.72-4.62,7.16-11.91,10-18.09C374,237.85,375.91,233,379,220.74Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "350.583px 221.448px"
    },
    id: "elokek8kz3md",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.26,151.78s-4.78,15,6.48,33.55c6.7,11,16.69,28,16.69,28s19-3.77,22.22-13.61c0,0-8.46-19.16-17.09-32.7S344.59,150.36,328.26,151.78Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "350.451px 182.398px"
    },
    id: "eld0n0ue3dwl",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Doggy--inject-2",
    className: "animable",
    style: {
      transformOrigin: "143.591px 315.931px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Doggya--inject-2",
    className: "animable",
    style: {
      transformOrigin: "143.591px 315.931px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.48,243.07c-3.63-11.55-3.53-19.25-1-23.68,1.68-3,6.92-4.15,9.16-4.34s3,1.53.95,3.53-1.28,3.88-.18,6.34a52.15,52.15,0,0,0,4.8,7.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "176.934px 229.053px"
    },
    id: "el6ma6vlu0koj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.51,251.49a14.62,14.62,0,0,1,2-.25,12.53,12.53,0,0,0,5.7-1.8,7.08,7.08,0,0,0,2.74-3.3,8.52,8.52,0,0,0,.24-3.34,9.63,9.63,0,0,0-.37-2.68c-.75-2.35-2.85-3.93-4.87-5.16-4.58-2.78-9.47-.37-16.25.81-5.14.89-15-7.25-27.09-2.9-11.79,4.26-11.92,16.91-14.29,27.05-3.87,16.55-6.84,12.41-16.62,29-7.86,13.37-10.62,23.63-19.44,36.72-4.37,6.47-13,17.9-17.41,32.1-5.45,17.53,1.14,30.42,12.46,37,10,5.85,15.45,7.85,29.39,6.86,7.77-.55,12.41-3.87,15.5-5.65,6.24,3.6,19.69-6.12,24.42-9.75,8.86-6.79,3.9-12.86-3.89-11.1a43.42,43.42,0,0,0-9.07,3.16s4.8-9.43,6.68-17.43c1.72-7.34.7-13.53-2.09-15.11,1.71-1.83,3.27-3.64,4.7-5.44.58,6.56,1.76,22.45,2.22,24,.61,2,4.74,5.92,8.49,4.9s11.63-4.54,12.78-7.91c1.53-4.52-3-5.22-10.71-3.21v-.17c.22-8.23.39-16.17.48-24.4.06-4.92.22-9.84.29-14.76.06-4,.48-7.94.78-11.91v0h0c.2-2.64.34-5.27.28-7.92-.14-6.64-1-13.87-.88-17,.11-4.85.78-9.9,4.32-13.34s8.14-5.18,12.24-7.66a27.92,27.92,0,0,0,4.24-3.07c1.24-1.11,3.69-4,2.8-5.85a10.65,10.65,0,0,1-7.22,1.64,5.78,5.78,0,0,1-2.76-1.38.5.5,0,0,1-.21-.4C219.12,251.62,219.33,251.54,219.51,251.49Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "171.081px 316.712px"
    },
    id: "elutaw8b9414l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.35,225.3c-13.51-.74-17.13,3.77-20.22,6.28s-9.13,13.2-2.29,15.35,13.22-5.78,13.22-5.78Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "185.529px 236.259px"
    },
    id: "eltziz792jypo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.15,284.93c0-1,.08-2.41.09-3.09,0-.86.86-1.72.91-2.58a113.58,113.58,0,0,1-16.78.25c-14.82-.65-21.45-8.41-21.45-8.41l-3.37-2.22a23.38,23.38,0,0,1-3.26,5.44c17,14,35.3,11.95,41.17,11.21Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "183.72px 277.481px"
    },
    id: "ely3bsm7bun5q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.16,248.69a8.23,8.23,0,0,1,5.25,2.69c.94,1.09,3.68,7.41,1.55,9.3s-6.91.06-7.46-4.61c0,0-7.43.22-9.62-2.92s1.42-4.11,4.73-4.24Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "226.481px 255.053px"
    },
    id: "elm0fmenmrxbi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.27,252s-3.07,2.16-2.61,4.12h.84a6.27,6.27,0,0,0,1.45,3.4,4.92,4.92,0,0,0,3.26,1.44c2.58,0,1.54-2.17,1-4.63S230.68,251.55,229.27,252Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "230.247px 256.452px"
    },
    id: "elicj7acungm7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.68,385.64a5.72,5.72,0,0,1,1.8,6s-3.32,5.37-18.89,7.1c-14.88,1.65-29.38-4.77-42.18,0s-7.5,14.47-8.83,17-5,.8-5-6.85,5.13-14.6,14.41-16.8,22.34-.44,34.74-.25c12.67.2,15.66-4.93,17.65-7C122.7,382.51,125,384.05,126.68,385.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "91.1478px 400.238px"
    },
    id: "ela8mkwep6fsl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.81,240.12c-.75-2.35-2.85-3.93-4.87-5.16-3.2-1.94-6.55-1.35-10.6-.41-1.23,1.08.56,4.12,2.87,5.8s6,7.82-2.37,9.92c-9.38,2.36-12.52,5.93-15.14,11.15-3.77,7.53-1.87,12.23.22,17.33,1.9,4.63,6.64,16.93,6.42,27,.16-2.28.42-4.63.37-6.92-.14-6.64-1.11-13.81-1-16.94.11-4.85.78-9.9,4.32-13.34s8.14-5.18,12.24-7.66a27.92,27.92,0,0,0,4.24-3.07c1.24-1.11,3.69-4,2.8-5.85a10.65,10.65,0,0,1-7.22,1.64,5.78,5.78,0,0,1-2.76-1.38.5.5,0,0,1-.21-.4c0-.19.25-.27.43-.32a14.62,14.62,0,0,1,2-.25,12.53,12.53,0,0,0,5.7-1.8,7.08,7.08,0,0,0,2.74-3.3,8.52,8.52,0,0,0,.24-3.34A9.63,9.63,0,0,0,229.81,240.12Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "213.921px 269.712px"
    },
    id: "ellngfm9zvwkj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.93,237.06c-.05-.06-.11-.12-.16-.19a7.74,7.74,0,0,0-.52-.83,2.57,2.57,0,0,0-1.32-.62c-.71-.21-1.39-.58-1.12-1.41.08-.24.29-.34.51-.44a4.58,4.58,0,0,1,5.21.17,10.35,10.35,0,0,1,4.19,3.9c.46.92-.7,3.77-.7,3.77a2.65,2.65,0,0,0-.24-1.29c-.54-1.62-3.21-1.92-4.59-2.38A3.35,3.35,0,0,1,223.93,237.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "225.789px 237.125px"
    },
    id: "elz3t1knrkfy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,268.53c3.49-3.39,8.14-5.18,12.24-7.66.54-.33,1.08-.68,1.6-1-7.08,4-15.27.85-19.18,3.63s-3,11.37,0,14.72c2.11,2.33-1.33,3.11-3.62,3.37.45,1.17.93,2.51,1.43,4l3.31-.51c0-1.3-.12-2.33-.1-3.15C205.78,277,206.45,272,210,268.53Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "212.44px 272.73px"
    },
    id: "elzi3oyl929vq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.94,243.91c2.38,2.32,5.67,5.33,8.16,8.18,2.11,2.41,3.72.63,5.5-10.5,1.53-9.56,2.37-11.07,4-11.62,1.25-.42,3.44-.14,3.83-1,.76-1.71-1.87-4.93-8-5.94C194.05,221.46,186.2,240.26,189.94,243.91Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "200.273px 237.984px"
    },
    id: "eluapuhxee2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.19,263.93c-.31,1-.52,1.48-.52,1.48s4.61,6.55,19.83,9.67,20.76.77,20.76.77a17.69,17.69,0,0,1,.59-2.2s.77.59.48,4.14c-.21,2.56-.56,3.65-1.94,4-4.28,1-12.86.89-21.27-1-12.93-2.9-20-8.37-21.15-9.66s-.75-2.34.15-5S164.66,263.4,166.19,263.93Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "184.829px 273.042px"
    },
    id: "el0of8qk54g7v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elo7flaqdbf4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.19,263.93c-.31,1-.52,1.48-.52,1.48s4.61,6.55,19.83,9.67,20.76.77,20.76.77a17.69,17.69,0,0,1,.59-2.2s.77.59.48,4.14c-.21,2.56-.56,3.65-1.94,4-4.28,1-12.86.89-21.27-1-12.93-2.9-20-8.37-21.15-9.66s-.75-2.34.15-5S164.66,263.4,166.19,263.93Z",
    style: {
      opacity: 0.3,
      transformOrigin: "184.829px 273.042px"
    },
    className: "animable",
    id: "elmgraiknisli"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M187.24,345.76c-4.46-2.58-14.87-.4-24.25,11.17,0,0,.39-7.33,9.26-12.47s15.31-3.41,17.68-1.71Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "176.46px 348.985px"
    },
    id: "els0ydazc9f2p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.59,377c-1.82.71-2.94,1.28-2.94,1.28-2.35,4.78-5.47,10-5.47,10S183.49,382.57,185.59,377Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "181.385px 382.64px"
    },
    id: "ellznakdn2fr8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.8,375.54A6.61,6.61,0,0,0,196,375a7.1,7.1,0,0,0-1.62.64,8.35,8.35,0,0,0-1.38,1c-.16.15-1.08,1-.78,1.25.09.06.2,0,.29,0a13.71,13.71,0,0,1,3.81-1.94A15.15,15.15,0,0,1,197.8,375.54Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "194.98px 376.458px"
    },
    id: "el1yzc806ysiq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.05,377.81a3.67,3.67,0,0,0-.53-.92c-2.26.38-4.73,1.11-5.25,3.1,0,.07,0,.33.14.24a17.58,17.58,0,0,1,2.91-1.68A11.65,11.65,0,0,1,200.05,377.81Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "197.16px 378.569px"
    },
    id: "eliym10bywvgk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.9,357.87a3.78,3.78,0,0,0-1.73-.73l-.34.07a4.83,4.83,0,0,0-2.46,1.3s0,.23,0,.2a11.27,11.27,0,0,1,3.56-.83C214.29,357.86,214.6,357.86,214.9,357.87Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "212.635px 357.926px"
    },
    id: "elp5dxob99pm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.69,359.36a2.32,2.32,0,0,0-.3-.93,5.32,5.32,0,0,0-.8.12c-.81.2-1.87.58-2.06,1.51,0,0,0,.17.08.15a14.61,14.61,0,0,1,2.39-.81C215.23,359.37,215.46,359.37,215.69,359.36Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "214.11px 359.321px"
    },
    id: "el8jkgl6crcuy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.75,401.38c-1.83-.43-3.94.87-5.22,2.13a7.94,7.94,0,0,0-2.12,3.8,9.2,9.2,0,0,0-.23,2.22,8.47,8.47,0,0,0,.1,1.12,2.88,2.88,0,0,0,.2,1.05c.08.14.27.25.41.16a.41.41,0,0,0,.14-.37,10.82,10.82,0,0,1,.41-3.63,12.36,12.36,0,0,1,1.71-3.13c1.25-1.64,2.91-2.08,4.62-3C68.88,401.67,68.88,401.41,68.75,401.38Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "65.0143px 406.594px"
    },
    id: "el1gqusxr1owd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,405.19c-.94,0-1.91,1-2.39,1.76a5.54,5.54,0,0,0-.9,3.33c.05.28.57.59.78.29a7,7,0,0,0,.71-1.95,4.52,4.52,0,0,1,2.15-2.71C67.72,405.71,67.24,405.2,67,405.19Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "65.5939px 407.941px"
    },
    id: "elv5b2mq9ntqk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.64,390.59c-5.36.44-10.54,5.08-12.21,10,0,.1.1.4.21.25,3.37-4.44,6.75-7.94,12.3-9.52C64.44,391.2,64,390.56,63.64,390.59Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "57.7973px 395.735px"
    },
    id: "elg40dy3z4hy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.23,389.64c-2.3-.41-5.37,1.92-6.85,3.51-.19.2.15.68.39.57a30.65,30.65,0,0,0,3.42-2.09,28.11,28.11,0,0,1,3.28-1.37C60.77,390.12,60.43,389.68,60.23,389.64Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "56.9566px 391.664px"
    },
    id: "elvpeyatmpxu",
    className: "animable"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssociat);
export default __webpack_public_path__ + "static/media/associat.ab65cba58cfb57e4a07294fbe2c82833.svg";
export { ForwardRef as ReactComponent };